<mat-toolbar
    class="flex items-center gap-3 px-4 py-2 border-b"
    [class.sticky]="sticky"
    style="
        background: var(--mat-sys-color-surface);
        border-color: var(--mat-sys-color-outline-variant);
        backdrop-filter: saturate(180%) blur(6px);
    "
>
    <div class="flex items-center gap-3">
        <ng-content select="[left]"></ng-content>
    </div>

    <div class="flex-1 min-w-0">
        <ng-content></ng-content>
    </div>

    <div class="flex items-center gap-3">
        <ng-content select="[right]"></ng-content>
    </div>
</mat-toolbar>
